import React, { useState } from "react";

import { useMutation } from "@tanstack/react-query";

import { updateFarmVerificationSize } from "services";

import { UPDATE_FARM_VERIFICATION_SIZE } from "consts";

import { Button, Col, Form, InputNumber, Modal, Row, Typography, Message as message } from "components";

export const FarmSizeForm = ({ farmId, size, onSuccess }: { farmId: string; size: number | null; onSuccess: () => void }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingSize, setPendingSize] = useState<number | null>(null);

  const { mutate, isPending } = useMutation({
    mutationKey: [UPDATE_FARM_VERIFICATION_SIZE],
    mutationFn: updateFarmVerificationSize,
    onSuccess: () => {
      message({
        content: "Farm size updated",
        icon: "gremlin",
      });

      setShowConfirmModal(false);
      onSuccess();
    },
  });

  const handleSubmit = (v: { size: number }) => {
    setPendingSize(v.size);
    setShowConfirmModal(true);
  };

  const handleConfirm = () => {
    if (pendingSize !== null) {
      mutate({
        farmId,
        size: pendingSize,
      });
    }
  };

  return (
    <>
      <Form onFinish={handleSubmit}>
        <Row align="middle">
          <Col md={16}>
            <InputNumber name="size" label="Farm size (ha)" rules={[{ required: true }]} min={0} initialValue={size ?? undefined} />
          </Col>

          <Col md={8}>
            <Button loading={isPending} type="primary" htmlType="submit">
              Save
            </Button>
          </Col>
        </Row>
      </Form>
      <Modal
        title="Confirm size change"
        showModal={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        onOk={handleConfirm}
        okText="Yes, update size"
        cancelText="Cancel"
        content={
          <>
            <Typography variant="paragraph-m" bold>
              Are you sure?
            </Typography>
            <Typography variant="paragraph-m">
              You are about to change the farm size from <strong>{size ? `${size} ha` : "Unknown"}</strong> to <strong>{pendingSize} ha</strong>.
            </Typography>
          </>
        }
      />
    </>
  );
};
